/* istanbul ignore file */
import { ShowSection, ShowPageLayout } from 'framework/ui/layout';
import ServiceCatalogHeader from 'domain/organization/serviceCatalog/shared/ServiceCatalogHeader';
import ArchiveServiceCatalogButton from 'domain/organization/serviceCatalog/shared/button/ArchiveServiceCatalogButton';
import AssignServiceCatalogOwnerButton from 'domain/organization/serviceCatalog/shared/button/AssignServiceCatalogOwnerButton';
import SingleServiceCatalogBreadcrumbs from 'domain/organization/serviceCatalog/shared/SingleServiceCatalogBreadcrumbs';
import ViewServiceCatalogPageMenu from 'domain/organization/serviceCatalog/Show/ViewServiceCatalogPageMenu';
import ServiceHealthField from 'domain/organization/serviceCatalog/shared/field/ServiceHealthField';
import { EmployeeLinkFieldWithNameLoading } from 'domain/shared/employee';
import ActiveKpiStructure from '../kpi/Show/ActiveKpiStructure';

const ViewServiceCatalogPageContent = () => {
  return (
    <ShowPageLayout
      entityHeader={
        <>
          <ServiceCatalogHeader />
          <EmployeeLinkFieldWithNameLoading source="owner" />
        </>
      }
      breadcrumbs={<SingleServiceCatalogBreadcrumbs />}
      headerButtons={[
        <AssignServiceCatalogOwnerButton statusSource="status" />,
        <ArchiveServiceCatalogButton statusSource="status" />,
      ]}
      menu={<ViewServiceCatalogPageMenu />}
    >
      <ShowSection title="Service health" titleVariant="h4">
        <ServiceHealthField label="Issues" source="currentHealth" />
      </ShowSection>
      <ShowSection title="Active KPI structure" titleVariant="h4">
        <ActiveKpiStructure />
      </ShowSection>
    </ShowPageLayout>
  );
};

export default ViewServiceCatalogPageContent;
